import { useSuspenseQuery } from '@tanstack/react-query';
import React from 'react';
import { useAuthUserContext } from './contexts';

export const TokenLoader = ({
  children,
  debugString,
}: {
  children: (token: string) => React.ReactNode;
  debugString: string;
}) => {
  const authUser = useAuthUserContext();
  const key = ['get-auth-token', authUser.uid];
  const { data: token } = useSuspenseQuery({
    queryKey: key,
    queryFn: () => {
      console.debug(`[useSuspenseQuery] ${debugString}`, key);
      return authUser.getIdToken();
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
  if (!token) {
    throw new Error('Token is undefined');
  }
  return <>{children(token)}</>;
};
